require('./loansForAresTypeUserView.scss');
const PropTypes = require('prop-types');

// @vendor
const React = require('react');
const { connect } = require('react-redux');
const Immutable = require('immutable');

// @commons
const { OKCover } = require('commonsComponents/OKCover');
const OKHeaderLanding = require('components/commons/OKHeaderLanding/OKHeaderLanding');
const { OKButton } = require('components/commons/OKButton/OKButton');

//@constants
const GLOBAL_POSITION_BOXES = require('constants/globalPositionBoxes');
const {
    GRAPHIC_TUTOR_TYPE_2
} = require('constants/index');
// @components
const GlobalPositionLoans = require('components/globalPosition/globalPositionLoans/globalPositionLoans');
const WebappRender = require('components/conditionalRender/webappRender');
const { CallMeBack } = require('components/callMeBack/callMeBack');
const TutorialLauncher = require('components/tutorial/tutorialLauncher');
const WizardError = require('components/commons/wizardError/wizardError');

//@actions
const { requestPublicInformation, outdateGlobalPosition } = require('actions/myGlobalPosition');

// @helpers
const { formatText } = require('core/i18n').i18n;

// @utilities
const { recordLinkV2 } = require("utilities/tagging");

class LoansForAresTypeUserView extends React.Component {
    buildLoansContent() {
        const {
            immLoans,
            landingBoxes,
            immProfile,
            immGlobalPosition,
            requestPublicInformation,
            outdateGlobalPosition,
        } = this.props;
        const expanded = landingBoxes.includes(
            GLOBAL_POSITION_BOXES.LOANS_LANDING
        );
        const mortgagesIsEmpty = immLoans.get('loansByOrder').isEmpty();

        if (!mortgagesIsEmpty) {
            return (
                <div
                    className="col-xs-12-cc-6 loans-for-ares-type-user-view__section"
                    id="loans-mortgages-loans"
                >
                    <GlobalPositionLoans
                        id={GLOBAL_POSITION_BOXES.LOANS_LANDING}
                        immLoans={immLoans}
                        expanded={expanded}
                        isOnPG={false}
                        immProfile={immProfile}
                    />
                </div>
            );
        }
        if (immGlobalPosition.get("error") && immProfile.get("isAresUser")) {
            const handleRetryButton = () => {
                outdateGlobalPosition();
                requestPublicInformation();
                recordLinkV2({
                    categoriaEvento: window.utag_last_name || "prestamos-hipotecas/vista general",
                    accionEvento: "reintentar",
                });
            };
            const errorSubMessageText = (
                <div>
                    <div>Lo sentimos, se ha producido un error</div>
                    <div>
                        Por favo, Inténtalo de nuevo en unos mintos a llámanos
                        al
                    </div>
                    <span className="loans-for-ares-type-user-view__phone-number">
                        <label>{"+34 91 177 33 10"}</label>
                    </span>
                </div>
            );

            return (
                <WizardError
                    errorMessage={"Se produjo un error"}
                    errorSubMessage={errorSubMessageText}
                >
                    <section className="row no-gutter loans-for-ares-type-user-view__try-button">
                        <OKButton
                            modifier="primary"
                            onClick={handleRetryButton}
                        >
                            Reintentar
                        </OKButton>
                    </section>
                </WizardError>
            );
        }
    }

    render() {
        const loansWafer = this.buildLoansContent();
        const tutorial = (
            <TutorialLauncher
                type={GRAPHIC_TUTOR_TYPE_2}
                title={'Préstamos e hipotecas'}
            />
        );
        return (
            <div>
                <div className="container-fluid">
                    <div className="row">
                        <OKCover
                            size="small"
                            section="loansmortgages"
                            customClass="col-xs-12"
                    >
                            <OKHeaderLanding
                                title={formatText('loansForAresLanding-title')}
                                inputClassName="ok-header-landing--loansmortgages"
                                tutorial={tutorial}
                        />
                        </OKCover>
                    </div>
                </div>
                <div className="grid-view__body">
                    <div className="container-fluid grid-view--content-position-positive">
                        <div className="row">
                            <div className="col-xs-12 col-md-9-cc-12">
                                <div className="row">
                                    <div className="col-md-12">
                                        <div className="row">{loansWafer}</div>
                                    </div>
                                </div>
                            </div>
                            <WebappRender>
                                <div className="col-xs-12 col-md-3">
                                    <div className="row">
                                        <div className="col-xs-6 col-md-12">
                                            <CallMeBack isSmall={true} />
                                        </div>
                                    </div>
                                </div>
                            </WebappRender>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

const combineCredits = ({ creditsInvestment, creditsPregranted }) => {
    const byId = creditsInvestment
        .get('byId')
        .mergeDeep(creditsPregranted.get('byId'));
    const byOrder = creditsInvestment
        .get('byOrder')
        .concat(creditsPregranted.get('byOrder'));
    const hasPregrantedCredit = creditsPregranted.get('byOrder').count() > 0;

    return Immutable.fromJS({
        byId,
        byOrder,
        hasPregrantedCredit,
        anyAccountWithoutPregrantedCredit: creditsPregranted.get(
            'anyAccountWithoutPregrantedCredit'
        ),
    });
};

LoansForAresTypeUserView.propTypes = {
    immCredits: PropTypes.object.isRequired,
    immLoans: PropTypes.object.isRequired,
    landingBoxes: PropTypes.object,
    route: PropTypes.object.isRequired,
    immProfile: PropTypes.object.isRequired,
    immGlobalPosition: PropTypes.object.isRequired,
    requestPublicInformation: PropTypes.func.isRequired,
    outdateGlobalPosition: PropTypes.func.isRequired,
};

module.exports = connect(
    (state) => ({
        immCredits: combineCredits(state),
        immLoans: state.loans,
        landingBoxes: state.landings.get('expandedBoxes').get('pg'),
        immProfile: state.profile,
        immGlobalPosition: state.globalPosition,
    }),
    {
        requestPublicInformation: requestPublicInformation,
        outdateGlobalPosition: outdateGlobalPosition,
    }
)(LoansForAresTypeUserView);
